export const Unicode = {
  EnDash: '\u2013',
  Hellip: '\u2026',
};
